import { draftColors } from "modules/proposals/draft/draftDesignTokens";

export const worksheetNumberProps = { inputMode: "decimal" as const, min: 0, step: "any" };
export const worksheetSellingGrid = {
  display: "grid",
  gap: { xs: 1, lg: 0.5 },
  alignItems: "start",
  gridTemplateColumns: {
    xs: "1fr 1fr",
    md: "repeat(3, 1fr)",
    lg: "minmax(120px, 2fr) minmax(52px, .65fr) minmax(62px, .8fr) minmax(76px, 1fr) repeat(2, minmax(58px, .7fr)) repeat(2, minmax(76px, 1fr)) minmax(58px, .7fr) repeat(2, minmax(76px, 1fr)) 48px 40px",
  },
  "& > :first-of-type": { gridColumn: { xs: "1 / -1", lg: "auto" } },
};
export const worksheetFieldSx = {
  "& .MuiInputBase-root": {
    fontSize: 13,
    backgroundColor: draftColors.surface,
    borderRadius: "6px",
    minHeight: 30,
  },
  "& .MuiInputBase-input": { padding: "6px 8px", minWidth: 0 },
  "& .MuiInputBase-multiline": { padding: 0 },
  "& .MuiSelect-select.MuiSelect-select": { padding: "6px 28px 6px 8px", minHeight: "18px" },
  "& .MuiInputLabel-root": { fontSize: 12 },
  "& .MuiOutlinedInput-notchedOutline": { borderColor: draftColors.borderInput },
  "& input[type=number]": { MozAppearance: "textfield" },
  "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button": {
    WebkitAppearance: "none",
    margin: 0,
  },
};

export const worksheetCalculatedFieldSx = {
  "& .MuiInputBase-root": { backgroundColor: "transparent", fontWeight: 600 },
  "& .MuiOutlinedInput-notchedOutline": { border: 0 },
};

// Dense desktop cost rows; retain comfortable controls on touch-sized layouts.
export const worksheetCompactFieldSx = {
  "& .MuiInputBase-root": {
    fontSize: 13,
    minHeight: { xs: 40, md: 28 },
    height: { xs: 40, md: 28 },
  },
  "& .MuiInputBase-input": {
    padding: { xs: "8px 6px", md: "3px 6px" },
    lineHeight: "20px",
    minWidth: 0,
  },
  "& .MuiSelect-select.MuiSelect-select": {
    padding: { xs: "8px 26px 8px 6px", md: "3px 26px 3px 6px" },
    minHeight: "20px",
  },
  "& .MuiIconButton-root": {
    padding: { xs: "8px", md: "3px" },
    minWidth: { xs: 40, md: 24 },
    minHeight: { xs: 40, md: 24 },
  },
};

// Header-only density; mobile keeps labeled touch-sized fields.
export const worksheetHeaderFieldSx = {
  "& .MuiInputBase-root": {
    fontSize: { xs: 13, lg: 12 },
    minHeight: { xs: 40, lg: 28 },
    height: { xs: 40, lg: 28 },
  },
  "& .MuiInputBase-input": {
    padding: { xs: "8px 6px", lg: "4px 5px" },
    minWidth: 0,
    lineHeight: "20px",
  },
  "& .MuiSelect-select.MuiSelect-select": {
    padding: { xs: "8px 24px 8px 6px", lg: "4px 20px 4px 5px" },
    minHeight: "20px",
  },
  "& .MuiSelect-icon": { right: 2, fontSize: 16 },
  "& .MuiInputLabel-root": { fontSize: { xs: 12, lg: 11 } },
};
